/* eslint-disable */
import { AxiosInstance } from 'axios'

import * as MfaGenerateUserDeviceToken from './mfa-generate-user-device-token'
import * as MfaVerifyOtp from './mfa-verify-otp'
import * as MfaReset from './mfa-reset'
import * as MfaRegisterTotp from './mfa-register-totp'
import * as ValidateUserToken from './validate-user-token'
import * as UpdateUser from './update-user'
import * as ActivateUser from './activate-user'
import * as RegisterUser from './register-user'
import * as ResetUserPassword from './reset-user-password'
import * as ResendUserActivation from './resend-user-activation'
import * as SendUserVerification from './send-user-verification'
import * as Authenticate from './authenticate'
import * as GetLoginDomain from './get-login-domain'
import * as AuthenticatePartnerSso from './authenticate-partner-sso'
import * as GeneratePartnerToken from './generate-partner-token'
import * as GetTwoStepAuthenticationHelpLink from './get-two-step-authentication-help-link'
import * as ValidateRegistrationToken from './validate-registration-token'
import * as GetOrderStatus from './get-order-status'
import * as RegisterOrderUser from './register-order-user'
import * as Logout from './logout'
import * as ValidateEmailVerificationToken from './validate-email-verification-token'
import * as VerifyEmail from './verify-email'
import * as VerifyPasskeyLogin from './verify-passkey-login'
import * as CreatePasskey from './create-passkey'
import * as CreateTrustedDevice from './create-trusted-device'
import * as CreatePasskeyState from './create-passkey-state'
import * as GetPasskeyCredentials from './get-passkey-credentials'
import * as GetTrustedDeviceStatus from './get-trusted-device-status'
import * as GetTrustedDeviceChallenge from './get-trusted-device-challenge'
import * as VerifyTrustedDeviceChallenge from './verify-trusted-device-challenge'
import * as CreateTrustedDeviceConfirmation from './create-trusted-device-confirmation'
import * as ConfirmTrustedDevice from './confirm-trusted-device'
import * as DenyTrustedDevice from './deny-trusted-device'


type MfaGenerateUserDeviceTokenRequest = MfaGenerateUserDeviceToken.Request
type MfaGenerateUserDeviceTokenResponse = MfaGenerateUserDeviceToken.Response
type MfaVerifyOtpRequest = MfaVerifyOtp.Request
type MfaVerifyOtpResponse = MfaVerifyOtp.Response
type MfaResetRequest = MfaReset.Request
type MfaResetResponse = MfaReset.Response
type MfaRegisterTotpRequest = MfaRegisterTotp.Request
type MfaRegisterTotpResponse = MfaRegisterTotp.Response
type ValidateUserTokenRequest = ValidateUserToken.Request
type ValidateUserTokenResponse = ValidateUserToken.Response
type UpdateUserRequest = UpdateUser.Request

type ActivateUserRequest = ActivateUser.Request

type RegisterUserRequest = RegisterUser.Request
type RegisterUserResponse = RegisterUser.Response
type ResetUserPasswordRequest = ResetUserPassword.Request
type ResetUserPasswordResponse = ResetUserPassword.Response
type ResendUserActivationRequest = ResendUserActivation.Request

type SendUserVerificationRequest = SendUserVerification.Request

type AuthenticateRequest = Authenticate.Request
type AuthenticateResponse = Authenticate.Response
type GetLoginDomainRequest = GetLoginDomain.Request
type GetLoginDomainResponse = GetLoginDomain.Response
type AuthenticatePartnerSsoRequest = AuthenticatePartnerSso.Request
type AuthenticatePartnerSsoResponse = AuthenticatePartnerSso.Response
type GeneratePartnerTokenRequest = GeneratePartnerToken.Request
type GeneratePartnerTokenResponse = GeneratePartnerToken.Response
type GetTwoStepAuthenticationHelpLinkRequest = GetTwoStepAuthenticationHelpLink.Request
type GetTwoStepAuthenticationHelpLinkResponse = GetTwoStepAuthenticationHelpLink.Response
type ValidateRegistrationTokenRequest = ValidateRegistrationToken.Request

type GetOrderStatusRequest = GetOrderStatus.Request
type GetOrderStatusResponse = GetOrderStatus.Response
type RegisterOrderUserRequest = RegisterOrderUser.Request
type RegisterOrderUserResponse = RegisterOrderUser.Response
type LogoutRequest = Logout.Request

type ValidateEmailVerificationTokenRequest = ValidateEmailVerificationToken.Request

type VerifyEmailRequest = VerifyEmail.Request
type VerifyEmailResponse = VerifyEmail.Response
type VerifyPasskeyLoginRequest = VerifyPasskeyLogin.Request
type VerifyPasskeyLoginResponse = VerifyPasskeyLogin.Response
type CreatePasskeyRequest = CreatePasskey.Request
type CreatePasskeyResponse = CreatePasskey.Response
type CreateTrustedDeviceRequest = CreateTrustedDevice.Request
type CreateTrustedDeviceResponse = CreateTrustedDevice.Response
type CreatePasskeyStateRequest = CreatePasskeyState.Request
type CreatePasskeyStateResponse = CreatePasskeyState.Response
type GetPasskeyCredentialsRequest = GetPasskeyCredentials.Request
type GetPasskeyCredentialsResponse = GetPasskeyCredentials.Response
type GetTrustedDeviceStatusRequest = GetTrustedDeviceStatus.Request
type GetTrustedDeviceStatusResponse = GetTrustedDeviceStatus.Response
type GetTrustedDeviceChallengeRequest = GetTrustedDeviceChallenge.Request
type GetTrustedDeviceChallengeResponse = GetTrustedDeviceChallenge.Response
type VerifyTrustedDeviceChallengeRequest = VerifyTrustedDeviceChallenge.Request
type VerifyTrustedDeviceChallengeResponse = VerifyTrustedDeviceChallenge.Response
type CreateTrustedDeviceConfirmationRequest = CreateTrustedDeviceConfirmation.Request
type CreateTrustedDeviceConfirmationResponse = CreateTrustedDeviceConfirmation.Response
type ConfirmTrustedDeviceRequest = ConfirmTrustedDevice.Request
type ConfirmTrustedDeviceResponse = ConfirmTrustedDevice.Response
type DenyTrustedDeviceRequest = DenyTrustedDevice.Request
type DenyTrustedDeviceResponse = DenyTrustedDevice.Response

const operations = {
  mfaGenerateUserDeviceToken: MfaGenerateUserDeviceToken.operation,
  mfaVerifyOtp: MfaVerifyOtp.operation,
  mfaReset: MfaReset.operation,
  mfaRegisterTotp: MfaRegisterTotp.operation,
  validateUserToken: ValidateUserToken.operation,
  updateUser: UpdateUser.operation,
  activateUser: ActivateUser.operation,
  registerUser: RegisterUser.operation,
  resetUserPassword: ResetUserPassword.operation,
  resendUserActivation: ResendUserActivation.operation,
  sendUserVerification: SendUserVerification.operation,
  authenticate: Authenticate.operation,
  getLoginDomain: GetLoginDomain.operation,
  authenticatePartnerSso: AuthenticatePartnerSso.operation,
  generatePartnerToken: GeneratePartnerToken.operation,
  getTwoStepAuthenticationHelpLink: GetTwoStepAuthenticationHelpLink.operation,
  validateRegistrationToken: ValidateRegistrationToken.operation,
  getOrderStatus: GetOrderStatus.operation,
  registerOrderUser: RegisterOrderUser.operation,
  logout: Logout.operation,
  validateEmailVerificationToken: ValidateEmailVerificationToken.operation,
  verifyEmail: VerifyEmail.operation,
  verifyPasskeyLogin: VerifyPasskeyLogin.operation,
  createPasskey: CreatePasskey.operation,
  createTrustedDevice: CreateTrustedDevice.operation,
  createPasskeyState: CreatePasskeyState.operation,
  getPasskeyCredentials: GetPasskeyCredentials.operation,
  getTrustedDeviceStatus: GetTrustedDeviceStatus.operation,
  getTrustedDeviceChallenge: GetTrustedDeviceChallenge.operation,
  verifyTrustedDeviceChallenge: VerifyTrustedDeviceChallenge.operation,
  createTrustedDeviceConfirmation: CreateTrustedDeviceConfirmation.operation,
  confirmTrustedDevice: ConfirmTrustedDevice.operation,
  denyTrustedDevice: DenyTrustedDevice.operation,
}

const operationsWithAxiosResponse = {
  mfaGenerateUserDeviceToken: MfaGenerateUserDeviceToken.operationWithAxiosResponse,
  mfaVerifyOtp: MfaVerifyOtp.operationWithAxiosResponse,
  mfaReset: MfaReset.operationWithAxiosResponse,
  mfaRegisterTotp: MfaRegisterTotp.operationWithAxiosResponse,
  validateUserToken: ValidateUserToken.operationWithAxiosResponse,
  updateUser: UpdateUser.operationWithAxiosResponse,
  activateUser: ActivateUser.operationWithAxiosResponse,
  registerUser: RegisterUser.operationWithAxiosResponse,
  resetUserPassword: ResetUserPassword.operationWithAxiosResponse,
  resendUserActivation: ResendUserActivation.operationWithAxiosResponse,
  sendUserVerification: SendUserVerification.operationWithAxiosResponse,
  authenticate: Authenticate.operationWithAxiosResponse,
  getLoginDomain: GetLoginDomain.operationWithAxiosResponse,
  authenticatePartnerSso: AuthenticatePartnerSso.operationWithAxiosResponse,
  generatePartnerToken: GeneratePartnerToken.operationWithAxiosResponse,
  getTwoStepAuthenticationHelpLink: GetTwoStepAuthenticationHelpLink.operationWithAxiosResponse,
  validateRegistrationToken: ValidateRegistrationToken.operationWithAxiosResponse,
  getOrderStatus: GetOrderStatus.operationWithAxiosResponse,
  registerOrderUser: RegisterOrderUser.operationWithAxiosResponse,
  logout: Logout.operationWithAxiosResponse,
  validateEmailVerificationToken: ValidateEmailVerificationToken.operationWithAxiosResponse,
  verifyEmail: VerifyEmail.operationWithAxiosResponse,
  verifyPasskeyLogin: VerifyPasskeyLogin.operationWithAxiosResponse,
  createPasskey: CreatePasskey.operationWithAxiosResponse,
  createTrustedDevice: CreateTrustedDevice.operationWithAxiosResponse,
  createPasskeyState: CreatePasskeyState.operationWithAxiosResponse,
  getPasskeyCredentials: GetPasskeyCredentials.operationWithAxiosResponse,
  getTrustedDeviceStatus: GetTrustedDeviceStatus.operationWithAxiosResponse,
  getTrustedDeviceChallenge: GetTrustedDeviceChallenge.operationWithAxiosResponse,
  verifyTrustedDeviceChallenge: VerifyTrustedDeviceChallenge.operationWithAxiosResponse,
  createTrustedDeviceConfirmation: CreateTrustedDeviceConfirmation.operationWithAxiosResponse,
  confirmTrustedDevice: ConfirmTrustedDevice.operationWithAxiosResponse,
  denyTrustedDevice: DenyTrustedDevice.operationWithAxiosResponse,
}

export interface ApiClient {
  mfaGenerateUserDeviceToken: MfaGenerateUserDeviceToken.Operation,
  mfaVerifyOtp: MfaVerifyOtp.Operation,
  mfaReset: MfaReset.Operation,
  mfaRegisterTotp: MfaRegisterTotp.Operation,
  validateUserToken: ValidateUserToken.Operation,
  updateUser: UpdateUser.Operation,
  activateUser: ActivateUser.Operation,
  registerUser: RegisterUser.Operation,
  resetUserPassword: ResetUserPassword.Operation,
  resendUserActivation: ResendUserActivation.Operation,
  sendUserVerification: SendUserVerification.Operation,
  authenticate: Authenticate.Operation,
  getLoginDomain: GetLoginDomain.Operation,
  authenticatePartnerSso: AuthenticatePartnerSso.Operation,
  generatePartnerToken: GeneratePartnerToken.Operation,
  getTwoStepAuthenticationHelpLink: GetTwoStepAuthenticationHelpLink.Operation,
  validateRegistrationToken: ValidateRegistrationToken.Operation,
  getOrderStatus: GetOrderStatus.Operation,
  registerOrderUser: RegisterOrderUser.Operation,
  logout: Logout.Operation,
  validateEmailVerificationToken: ValidateEmailVerificationToken.Operation,
  verifyEmail: VerifyEmail.Operation,
  verifyPasskeyLogin: VerifyPasskeyLogin.Operation,
  createPasskey: CreatePasskey.Operation,
  createTrustedDevice: CreateTrustedDevice.Operation,
  createPasskeyState: CreatePasskeyState.Operation,
  getPasskeyCredentials: GetPasskeyCredentials.Operation,
  getTrustedDeviceStatus: GetTrustedDeviceStatus.Operation,
  getTrustedDeviceChallenge: GetTrustedDeviceChallenge.Operation,
  verifyTrustedDeviceChallenge: VerifyTrustedDeviceChallenge.Operation,
  createTrustedDeviceConfirmation: CreateTrustedDeviceConfirmation.Operation,
  confirmTrustedDevice: ConfirmTrustedDevice.Operation,
  denyTrustedDevice: DenyTrustedDevice.Operation,
}

export interface ApiClientWithAxiosResponse {
  mfaGenerateUserDeviceToken: MfaGenerateUserDeviceToken.OperationWithAxiosResponse,
  mfaVerifyOtp: MfaVerifyOtp.OperationWithAxiosResponse,
  mfaReset: MfaReset.OperationWithAxiosResponse,
  mfaRegisterTotp: MfaRegisterTotp.OperationWithAxiosResponse,
  validateUserToken: ValidateUserToken.OperationWithAxiosResponse,
  updateUser: UpdateUser.OperationWithAxiosResponse,
  activateUser: ActivateUser.OperationWithAxiosResponse,
  registerUser: RegisterUser.OperationWithAxiosResponse,
  resetUserPassword: ResetUserPassword.OperationWithAxiosResponse,
  resendUserActivation: ResendUserActivation.OperationWithAxiosResponse,
  sendUserVerification: SendUserVerification.OperationWithAxiosResponse,
  authenticate: Authenticate.OperationWithAxiosResponse,
  getLoginDomain: GetLoginDomain.OperationWithAxiosResponse,
  authenticatePartnerSso: AuthenticatePartnerSso.OperationWithAxiosResponse,
  generatePartnerToken: GeneratePartnerToken.OperationWithAxiosResponse,
  getTwoStepAuthenticationHelpLink: GetTwoStepAuthenticationHelpLink.OperationWithAxiosResponse,
  validateRegistrationToken: ValidateRegistrationToken.OperationWithAxiosResponse,
  getOrderStatus: GetOrderStatus.OperationWithAxiosResponse,
  registerOrderUser: RegisterOrderUser.OperationWithAxiosResponse,
  logout: Logout.OperationWithAxiosResponse,
  validateEmailVerificationToken: ValidateEmailVerificationToken.OperationWithAxiosResponse,
  verifyEmail: VerifyEmail.OperationWithAxiosResponse,
  verifyPasskeyLogin: VerifyPasskeyLogin.OperationWithAxiosResponse,
  createPasskey: CreatePasskey.OperationWithAxiosResponse,
  createTrustedDevice: CreateTrustedDevice.OperationWithAxiosResponse,
  createPasskeyState: CreatePasskeyState.OperationWithAxiosResponse,
  getPasskeyCredentials: GetPasskeyCredentials.OperationWithAxiosResponse,
  getTrustedDeviceStatus: GetTrustedDeviceStatus.OperationWithAxiosResponse,
  getTrustedDeviceChallenge: GetTrustedDeviceChallenge.OperationWithAxiosResponse,
  verifyTrustedDeviceChallenge: VerifyTrustedDeviceChallenge.OperationWithAxiosResponse,
  createTrustedDeviceConfirmation: CreateTrustedDeviceConfirmation.OperationWithAxiosResponse,
  confirmTrustedDevice: ConfirmTrustedDevice.OperationWithAxiosResponse,
  denyTrustedDevice: DenyTrustedDevice.OperationWithAxiosResponse,
}

export const createClient = (axios: AxiosInstance): ApiClient => {

  const apiClient = {}
  for (let [name, operation] of Object.entries(operations)) {
    // @ts-ignore
    apiClient[name] = (...args: any[]) => operation(axios, ...args)
  }

  return apiClient as ApiClient

}

export const createClientWithAxiosResponse = (axios: AxiosInstance): ApiClientWithAxiosResponse => {

  const apiClient = {}
  for (let [name, operation] of Object.entries(operationsWithAxiosResponse)) {
    // @ts-ignore
    apiClient[name] = (...args: any[]) => operation(axios, ...args)
  }

  return apiClient as ApiClientWithAxiosResponse

}

export {
  MfaGenerateUserDeviceTokenRequest, MfaGenerateUserDeviceTokenResponse,
  MfaVerifyOtpRequest, MfaVerifyOtpResponse,
  MfaResetRequest, MfaResetResponse,
  MfaRegisterTotpRequest, MfaRegisterTotpResponse,
  ValidateUserTokenRequest, ValidateUserTokenResponse,
  UpdateUserRequest,
  ActivateUserRequest,
  RegisterUserRequest, RegisterUserResponse,
  ResetUserPasswordRequest, ResetUserPasswordResponse,
  ResendUserActivationRequest,
  SendUserVerificationRequest,
  AuthenticateRequest, AuthenticateResponse,
  GetLoginDomainRequest, GetLoginDomainResponse,
  AuthenticatePartnerSsoRequest, AuthenticatePartnerSsoResponse,
  GeneratePartnerTokenRequest, GeneratePartnerTokenResponse,
  GetTwoStepAuthenticationHelpLinkRequest, GetTwoStepAuthenticationHelpLinkResponse,
  ValidateRegistrationTokenRequest,
  GetOrderStatusRequest, GetOrderStatusResponse,
  RegisterOrderUserRequest, RegisterOrderUserResponse,
  LogoutRequest,
  ValidateEmailVerificationTokenRequest,
  VerifyEmailRequest, VerifyEmailResponse,
  VerifyPasskeyLoginRequest, VerifyPasskeyLoginResponse,
  CreatePasskeyRequest, CreatePasskeyResponse,
  CreateTrustedDeviceRequest, CreateTrustedDeviceResponse,
  CreatePasskeyStateRequest, CreatePasskeyStateResponse,
  GetPasskeyCredentialsRequest, GetPasskeyCredentialsResponse,
  GetTrustedDeviceStatusRequest, GetTrustedDeviceStatusResponse,
  GetTrustedDeviceChallengeRequest, GetTrustedDeviceChallengeResponse,
  VerifyTrustedDeviceChallengeRequest, VerifyTrustedDeviceChallengeResponse,
  CreateTrustedDeviceConfirmationRequest, CreateTrustedDeviceConfirmationResponse,
  ConfirmTrustedDeviceRequest, ConfirmTrustedDeviceResponse,
  DenyTrustedDeviceRequest, DenyTrustedDeviceResponse,
}
